import { ProfileModel } from '@/app/shared/models';

export class UserDetail {
  public Id!: string;
  public FirstName!: string;
  public LastName!: string;
  public UserName!: string;
  public Document?: string;
  public DocumentType?: string;
  public Email?: string;
  public EmailConfirmed?: boolean;
  public PhoneNumber?: string;
  public PhoneNumberConfirmed?: boolean;
  public TwoFactorEnabled?: boolean;
  public LockoutEnd?: Date;
  public LockoutEnabled?: boolean;
  public AccessFailedCount?: number;
  public ForceChangePassword?: boolean;
  public Created!: Date;
  public Updated?: Date;
  public Profiles?: ProfileModel[];
}
